import angular from 'angular';
import admin from './admin';
import advisory from './advisory';
import home from './home';
import membership from './membership';
import reports from './reports';
import support from './support';
import demo from './demo';
import dashboard from './dashboard';

export default angular.module('app.components', [
  admin,
  advisory,
  home,
  membership,
  reports,
  support,
  demo,
  dashboard,
]).name;

console.log('app.components created');
